import { Link } from "gatsby"
import React, { useState } from "react"
import config from "../lib/config"
import DemoVideoModal from "./demo-video-modal"
import Logo from "./logo"

const navigation = {
  product: [
    { name: `Request a Demo`, href: "/request-a-demo" },
    { name: "Product Overview", href: "/solutions" },
    { name: "Take a Tour", isDemoLink: true },
  ],
  company: [
    { name: "Our Story", href: "/about" },
    { name: "Meet The Team", href: "/team" },
    { name: "Work With Us", href: "/work-with-us" },
  ],
  other: [{ name: "Special Thanks", href: "/special-thanks" }],
  social: [
    {
      name: "Email",
      href: `mailto:${config.contactEmail}`,
      icon: props => (
        <svg
          {...props}
          className="h-6 w-6"
          stroke="currentColor"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <path d="M12 12.713l-11.985-9.713h23.971l-11.986 9.713zm-5.425-1.822l-6.575-5.329v12.501l6.575-7.172zm10.85 0l6.575 7.172v-12.501l-6.575 5.329zm-1.557 1.261l-3.868 3.135-3.868-3.135-8.11 8.848h23.956l-8.11-8.848z" />
        </svg>
      ),
    },
    {
      name: "GitHub",
      href: "https://github.com/SchoolSafeApp",
      icon: props => (
        <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
          <path
            fillRule="evenodd"
            d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z"
            clipRule="evenodd"
          />
        </svg>
      ),
    },
  ],
}

export default function Example() {
  const [demoOpen, setDemoOpen] = useState(false)
  return (
    <footer className="bg-gray-100" aria-labelledby="footerHeading">
      {demoOpen ? (
        <DemoVideoModal closeModal={() => setDemoOpen(false)} />
      ) : null}
      <h2 id="footerHeading" className="sr-only">
        Footer
      </h2>
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8">
        <div className="overflow-hidden">
          <div className="space-y-8 xl:col-span-1 w-full mb-4 md:mb-0 md:w-96 float-left">
            <Logo light />
            <p className="text-gray-500 text-base">{config.siteDescription}</p>
            <div className="flex space-x-6">
              {navigation.social.map(item => (
                <Link
                  key={item.name}
                  to={item.href}
                  className="text-gray-400 hover:text-gray-500"
                >
                  <span className="sr-only">{item.name}</span>
                  <item.icon className="h-6 w-6" aria-hidden="true" />
                </Link>
              ))}
            </div>
          </div>
          <div className="w-full md:w-1/2 mt-12 float-right grid grid-rows-3 md:grid-rows-1 md:grid-cols-3 gap-8 xl:mt-0 xl:col-span-2">
            <div>
              <h3 className="text-sm font-semibold text-gray-400 tracking-wider uppercase">
                product
              </h3>
              <ul className="mt-4 space-y-4">
                {navigation.product.map(item =>
                  item.isDemoLink ? (
                    <li key={item.name}>
                      <button
                        onClick={() => setDemoOpen(true)}
                        className="text-base text-gray-500 hover:text-gray-900 outline-none focus:outline-none"
                      >
                        {item.name}
                      </button>
                    </li>
                  ) : (
                    <li key={item.name}>
                      <Link
                        to={item.href}
                        className="text-base text-gray-500 hover:text-gray-900"
                      >
                        {item.name}
                      </Link>
                    </li>
                  )
                )}
              </ul>
            </div>
            <div>
              <h3 className="text-sm font-semibold text-gray-400 tracking-wider uppercase">
                Company
              </h3>
              <ul className="mt-4 space-y-4">
                {navigation.company.map(item => (
                  <li key={item.name}>
                    <Link
                      to={item.href}
                      className="text-base text-gray-500 hover:text-gray-900"
                    >
                      {item.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h3 className="text-sm font-semibold text-gray-400 tracking-wider uppercase">
                Other
              </h3>
              <ul className="mt-4 space-y-4">
                {navigation.other.map(item => (
                  <li key={item.name}>
                    <Link
                      to={item.href}
                      className="text-base text-gray-500 hover:text-gray-900"
                    >
                      {item.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        <div className="mt-12 border-t border-gray-200 pt-8">
          <p className="text-base text-gray-400 xl:text-center">
            &copy; {new Date().getFullYear()} {config.siteTitle}. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>
  )
}
